export const TABS = {
  OVERVIEW: 'Overview',
  SETTINGS: 'Your Profile',
  TEAM: 'Your Team',
}

export const INPUT_NAMES = {
  CURRENT_MONTHLY_COST: 'currentMonthlyCost',
  MAX_BUDGET: 'maxBudget',
  DOWN_PAYMENT: 'downPayment',
  YEARS_IN_HOME: 'yearsInHome',
  RENTABLE_NIGHTS: 'rentableNights',
}

export const positioningTypes = {
  FIXED_RIGHT: 'FixedRight',
  RELATIVE: 'Relative',
}

export const VALID_TAB_VALUES = Object.keys(TABS).map(k => TABS[k])

export const MODAL_FIELD_INFO = {
  // ho
  CURRENT_MONTHLY_HOME_COSTS: 'CURRENT_MONTHLY_HOME_COSTS',
  FUTURE_MONTHLY_HOME_COSTS: 'FUTURE_MONTHLY_HOME_COSTS',
  DOWN_PAYMENT: 'DOWN_PAYMENT',
  YEARS_IN_HOME: 'YEARS_IN_HOME',
  RENTABLE_NIGHTS: 'RENTABLE_NIGHTS',
  // renter
  RENTER_CURRENT_MONTHLY_RENT_COSTS: 'CURRENT_MONTHLY_RENT_COSTS',
  RENTER_FUTURE_MONTHLY_HOME_COSTS: 'RENTER_FUTURE_MONTHLY_HOME_COSTS',
}
